module.exports = __webpack_public_path__ + "static/servicebg-2b5aaec2db5a22c8a072fbae26bbc7e8.jpg";